// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main-container__image[data-v-098badf6]{display:inline-block;background-color:#64bd63;border-radius:50%;color:whitesmoke;font-weight:bolder;text-align:center;cursor:pointer;transition:box-shadow 0.2s ease-in-out}.main-container__image[data-v-098badf6]:hover{box-shadow:0 0 25px #64bd63}\n", ""]);
// Exports
module.exports = exports;
